const pricingData = [
    {
        id: 1,
        type: "Regular",
        value: "10.",
        bandwidth: " 1GB",
        onlinespace: " 500MB",
        domain: "1",
        prMonth: "50",
        hidden: "-",
    },
    {
        id: 2,
        type: "Startup",
        value: "30.",
        bandwidth: " 2GB",
        onlinespace: " 1GB",
        domain: "3",
        prMonth: "200",
        hidden: "Hidden Fees: No",
    },
    {
        id: 3,
        type: "Business",
        value: "80.",
        bandwidth: " 4GB",
        onlinespace: " 2GB",
        domain: "Unlimited",
        prMonth: "Unlimited",
        hidden: "Hidden Fees: No",
    },
];

export default pricingData;